import { Button } from 'antd';
import {FormOutlined} 
from "@ant-design/icons";
import {useTranslation} from "react-i18next";

const ClearAddressLink = ({showLink, clearAddressFields}) => {
    const {t} = useTranslation();

    return (
            showLink
            ?
            <Button type="link" 
                    onClick={() => {
                        clearAddressFields();
                    }} 
                    icon={<FormOutlined />}
            >
                {t('action.clear_address')}
            </Button>
            :
            <></>
    );
}

export default ClearAddressLink;